import {EditorState, StateEffect, StateField} from '@codemirror/state'
import {EditorView} from '@codemirror/view'

/** Effect that will be triggered when mouse button is pressed or lifted.*/
const clickingChangeEffect = StateEffect.define<boolean>()

const mousedownObserver = EditorView.domEventObservers({
  mousedown: (_, view) => {
    // The mouse could move outside the boundaries of the editor before being released
    view.dom.ownerDocument.addEventListener(
      'mouseup',
      () => {
        view.dispatch({effects: clickingChangeEffect.of(false)})
      },
      {once: true},
    )

    view.dispatch({effects: clickingChangeEffect.of(true)})
  },
})

/** Field to store the clicking state on the editor state. */
const isClickingField = StateField.define<boolean>({
  create: () => false,
  update: (prev, tr) => tr.effects.find(eff => eff.is(clickingChangeEffect))?.value ?? prev,
  provide: () => [mousedownObserver],
})

/** Extension that tracks when the user is actively clicking on the editor. */
export const clickingExtension = [isClickingField]

/** Get the clicking state from the editor state. Throws an error if `clickingExtension` is not installed. */
export function isClicking(state: EditorState) {
  return state.field(isClickingField)
}
